import { render } from "./SaboteurVotesBox.vue?vue&type=template&id=1034af8b"
import script from "./SaboteurVotesBox.vue?vue&type=script&lang=js"
export * from "./SaboteurVotesBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__